// @ts-nocheck
import { summaryTableStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsSummaryTable";
import { css } from "styled-components";

Object.assign(summaryTableStyles, {
    orderLines: {
        gridContainer: {
            css: css`
                margin-bottom: 3rem;
            `,
        },
    },
});
